type SchoolIdInput = string | number | null | undefined

const parseSchoolId = (value: SchoolIdInput): number | null => {
  if (typeof value === "number") {
    return Number.isFinite(value) && value > 0 ? value : null
  }
  if (typeof value === "string") {
    const id = parseInt(value, 10)
    return Number.isFinite(id) && id > 0 ? id : null
  }
  return null
}

const getSchoolIdFromBootstrappedData = (): number | null => {
  if (typeof window === "undefined") return null
  return parseSchoolId(window.bootstrappedData?.school?.id)
}

const getSchoolIdFromLegacyStore = (): number | null => {
  if (typeof window === "undefined") return null
  return parseSchoolId(window.App?.getStore?.("school")?.getState?.()?.school?.id)
}

const getSchoolIdFromLocalStorage = (): number | null => {
  if (typeof window === "undefined") return null
  return parseSchoolId(localStorage.getItem("PW_SPACE"))
}

type GetEmbedSchoolIdOptions = {
  search?: string
  fallbackSchoolId?: number
}

export const getEmbedSchoolId = ({
  search,
  fallbackSchoolId
}: GetEmbedSchoolIdOptions = {}): number | null => {
  const searchParams = new URLSearchParams(search || "")
  const schoolIdFromQuery = parseSchoolId(searchParams.get("school_id"))
  if (schoolIdFromQuery) return schoolIdFromQuery

  const schoolIdFromBootstrappedData = getSchoolIdFromBootstrappedData()
  if (schoolIdFromBootstrappedData) return schoolIdFromBootstrappedData

  const schoolIdFromLegacyStore = getSchoolIdFromLegacyStore()
  if (schoolIdFromLegacyStore) return schoolIdFromLegacyStore

  const schoolIdFromLocalStorage = getSchoolIdFromLocalStorage()
  if (schoolIdFromLocalStorage) return schoolIdFromLocalStorage

  return parseSchoolId(fallbackSchoolId)
}
